const Luigi = {
  level1: '#C0E6C8',
  Lu100: '#C0E6C8',
  level2: '#97D5A5',
  Lu200: '#97D5A5',
  level3: '#6AC682',
  Lu300: '#6AC682',
  level4: '#07AD4B',
  Lu400: '#07AD4B',
  level5: '#009E43',
  Lu500: '#009E43',
  level6: '#007B2C',
  Lu600: '#007B2C',
};

export { Luigi };
